export const TAB_NAMES = ['users', 'teams', 'groups', 'invitations'];
export const DEFAULT_TAB_NAME = TAB_NAMES[0];
export const TEAMS_TAB_NAME = TAB_NAMES[1];

export const STATUS_ACTIVE = 'active';
